module.exports = __webpack_public_path__ + "img/ico_pickup.355a85f.svg";